// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__-J-Ls","banner__logo":"Banner_banner__logo__akaMa"};